export default (url) => {
    return new Promise((resolve, reject) => {
        const scriptTag = document.createElement('script');
        // @ts-expect-error TS2322: Type (value: void | PromiseLike<void>) => void is not assignable to type
        scriptTag.onload = resolve;
        scriptTag.src = url;
        if (!document.body) {
            return reject('Missing document element!');
        }
        document.body.appendChild(scriptTag);
    });
};
